import { CircularProgress, Menu, MenuItem } from "@material-ui/core";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import InsertEmoticonOutlinedIcon from "@mui/icons-material/InsertEmoticonOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import { defaultGroupTask } from "actions/groupTask/defaultGroupTask";
import { editProjectGroup } from "actions/projectGroup/editProjectGroup";
import { TimeRangePopover } from "components/CustomPopover";
import WPReactTable from "components/WPReactTableViewProjectTask";
import { exportToCSV } from "helpers/utils/exportData";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { find, get, isNil, isObject, join, size } from "lodash";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import LoadingBox from "../../../../components/LoadingBox";
import { Container } from "../../../../components/TableComponents";
import HeaderTableAllGroup from "./components/HeaderTableAllGroup";
import ProjectGroupGrid from "./components/PropjectGroupGrid";
// import { COLUMNS_PROJECT_TABLE } from "./constants/Columns";
import EmptyPersonalBoard from "./Intro/EmptyPersonalBoard";
import EmptyWorkingBoard from "./Intro/EmptyWorkingBoard";
import EmptyWorkingGroup from "./Intro/EmptyWorkingGroup";
import "./styles/style.scss";
import EditProjectModal from "views/ProjectGroupPage/Modals/EditProject";
// import { _sortByAscGroupTable, _sortByDescGroupTable } from "./utils";
import EditIcon from "@mui/icons-material/Edit";
import Icon from "@mdi/react";
import {
  mdiAccountSupervisor,
  mdiDoNotDisturb,
  mdiEye,
  mdiEyeOff,
  mdiLink,
  mdiSettings,
  mdiShare,
} from "@mdi/js";
import {
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import ShareProjectModal from "components/ShareProjectModal/ShareProjectModal";
import { CustomLayoutContext } from "components/CustomLayout";
// import AddMemberModal from "views/JobDetailPage/ListPart/ListHeader/AddMemberModal";
import MembersSettingModal from "views/ProjectPage/Modals/MembersSetting";
import ManagerLabelModal from "views/ProjectGroupPage/Modals/ManagerLabel";
import MoveGroupAndTabletModal from "views/ProjectGroupPage/components/MoveGroupAndTabletModal";
import ColorGroupPickerPopover from "views/ProjectGroupPage/Modals/ColorGroupPickerPopover";
import { apiService } from "constants/axiosInstance";
import ProjectTableDeny from "../ProjectTableDeny";
import CreateProjectGroup from "views/ProjectGroupPage/Modals/CreateProjectGroup";

// const KEY_LOCAL_STORAGE_SORT = "sort_project_table";

function AllProjectTable({
  expand,
  handleExpand,
  projects,
  filterType,
  labelType,
  handleFilterType,
  handleSearch,
  handleFilterLabel,
  timeType,
  handleTimeType,
  handleSortType,
  type_data = null,
  handleShowOrHideProject,
  handleSortProject,
  handleSortProjectGroup,
  handleSortProjectGroupAndUpdateReducer,
  handleUpdateProjectGroup,
  handleOpenModal,
  bgColor,
  showHidePendings,
  projectGroup,
  groupID,
  isShared,
  isFiltering,
  setIsFiltering,
  doReloadList,
  activeLoading,
  setActiveLoading,
  canModifyProjectGroup = false,
  handleSelectColor,
  doEditProjectGroup,
  openEditProject,
  setOpenEditProject,
  editProjectProps,
  updateProjectData,
  localOption,
  searchValue,
  openEdit,
  setOpenEdit,
  editProps,
}) {
  // const dataSort = localStorage.getItem(KEY_LOCAL_STORAGE_SORT);
  // const sortLocal = JSON.parse(dataSort);
  const { t } = useTranslation();
  const [timeAnchor, setTimeAnchor] = React.useState(null);
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const [curProject, setCurProject] = React.useState(null);
  const [showHideDisabled, setShowHideDisabled] = React.useState(false);
  const [projectSummary, setProjectSummary] = React.useState({});
  const [currentGroup, setCurrentGroup] = React.useState(null);
  const [currentGroupAction, setCurrentGroupAction] = React.useState(null);
  const [colorPickerProps, setColorPickerProps] = React.useState(null);
  const isDisplayGroupGrid = !groupID && !isShared;
  console.log(isDisplayGroupGrid, "isDisplayGroupGrid");
  const history = useHistory();
  const refFilterCustom = React.useRef(null);
  const [openShare, setOpenShare] = React.useState(false);
  const [openManagerLabelModal, setOpenManagerLabelModal] =
    React.useState(false);

  const { doOpenModal } = React.useContext(CustomLayoutContext);

  const onUnShareProject = () => doOpenModal("UN_SHARE_PROJECT", {});
  const [isOpenAddModal, setIsOpenAddModal] = React.useState(false);
  const [isProjectGroup, setIsProjectGroup] = React.useState(false);
  const [visible, setVisible] = React.useState(null);
  const [itemToMove, setItemToMove] = React.useState(null);
  const [loadingCheckDeny, setLoadingCheckDeny] = React.useState(
    isDisplayGroupGrid || isShared ? false : true
  );
  console.log(loadingCheckDeny, "loadingCheckDeny");
  const [isDeny, setIsDeny] = React.useState(
    isDisplayGroupGrid || isShared ? false : true
  );
  const canDelete = isDisplayGroupGrid
    ? canModifyProjectGroup
    : get(curProject, "can_delete", false);

  // const refData = useRef([]);
  const dispatch = useDispatch();

  function doOpenMenu(anchorEl, project, isProjectGroupParam = false) {
    setMenuAnchor(anchorEl);
    setCurProject(project);
    setIsProjectGroup(isProjectGroupParam);
  }
  const closeModal = (e) => setVisible(e);
  // const _handleSort = (key, idSort, array = null) => {
  //   switch (key) {
  //     case "ASC":
  //       localStorage.setItem(
  //         KEY_LOCAL_STORAGE_SORT,
  //         JSON.stringify({ key, idSort })
  //       );
  //       setSelectedSort({ key, idSort });

  //       return !array
  //         ? setData((prevState) => _sortByAscGroupTable(prevState, idSort))
  //         : _sortByAscGroupTable(array, idSort);
  //     case "DECS":
  //       localStorage.setItem(
  //         KEY_LOCAL_STORAGE_SORT,
  //         JSON.stringify({ key, idSort })
  //       );
  //       setSelectedSort({ key, idSort });
  //       return !array
  //         ? setData((prevState) => _sortByDescGroupTable(prevState, idSort))
  //         : _sortByDescGroupTable(array, idSort);
  //     default:
  //       setData(refData.current);
  //       setSelectedSort(null);
  //       localStorage.setItem(KEY_LOCAL_STORAGE_SORT, null);
  //       break;
  //   }
  // };

  const _handleDragEnd = (resultSort) => {
    const sortData = resultSort.map((item, index) => ({
      id: item.id,
      sort_index: index,
    }));
    handleSortProject(sortData);
    doReloadList();
  };

  const getCurrentGroup = async () => {
    try {
      const config = {
        url: "/project-group/detail",
        method: "get",
        params: {
          project_group_id: groupID,
        },
      };
      console.log(currentGroup, "test get");
      if (!groupID || groupID === "") return;
      const response = await apiService(config);
      let tmp = response?.data?.project_group;
      if (tmp) {
        setCurrentGroup(tmp);
        setIsDeny(false);
      } else {
        setIsDeny(true);
      }
    } catch (e) {
      setIsDeny(true);
    }
    setLoadingCheckDeny(false);
  };

  React.useEffect(() => {
    if (!groupID) {
      setIsDeny(false);
    }
  }, [groupID]);

  React.useEffect(() => {
    setShowHideDisabled(
      !isNil(
        find(
          showHidePendings.pendings,
          (pending) => pending === get(curProject, "id")
        )
      )
    );
  }, [showHidePendings, curProject]);
  React.useEffect(() => {
    // setCurProject((oldProject) =>
    //   find(projects.projects, { id: get(oldProject, "id") })
    // );
    // setProjectSummary(projects.summary);
  }, [projects]);
  React.useEffect(() => {
    if (
      !!groupID &&
      (currentGroup === null || (currentGroup && currentGroup.id !== groupID))
    ) {
      getCurrentGroup();
    }
    // setCurrentGroup(find(projectGroup, { id: groupID }));
  }, [groupID, projectGroup]);

  React.useEffect(() => {
    if (isShared) {
      setCurrentGroup(find(projectGroup, { is_shared: isShared }));
    }
  }, [isShared, projectGroup]);

  const onEdit = (evt, project) => doOpenMenu(evt, project);

  function renderEmptyView() {
    switch (type_data) {
      case 2:
        return <EmptyPersonalBoard />;
      default:
        if (!isNil(groupID)) {
          return <EmptyWorkingBoard groupID={groupID} projects={projects} />;
        } else return <EmptyWorkingGroup />;
    }
  }

  function _handleSetDefault(value) {
    if (value) dispatch(defaultGroupTask(value));
  }

  const _filterType = (index) => {
    handleFilterType(index);
    setIsFiltering(true);
  };

  const _filterLabel = (labelId) => {
    handleFilterLabel(labelId);
    setIsFiltering(true);
  };

  const _setTimeRangeAnchor = (e) => {
    setTimeAnchor(e.currentTarget);
  };

  const _exportData = () => {
    const data = projects.projects.map((project) => ({
      id: get(project, "id", ""),
      icon: get(project, "icon", ""),
      name: get(project, "name", ""),
      status: get(project, "state_name", ""),
      task_count:
        get(project, "statistic.waiting", 0) +
        get(project, "statistic.doing", 0) +
        get(project, "statistic.expired", 0) +
        get(project, "statistic.complete", 0) +
        get(project, "statistic.stop", 0),
      progress: `${get(project, "complete", 0)}%`,
      duration: get(project, "duration")
        ? `${get(project, "duration")} ngày (${get(
            project,
            "date_start"
          )} - ${get(project, "date_end")})`
        : "",
      priority: get(project, "priority_name", ""),
      members: join(
        get(project, "members", []).map((member) => get(member, "name")),
        ","
      ),
    }));

    exportToCSV(data, "projects");
  };

  const handleCopyText = (text) => {
    window.navigator.clipboard
      .writeText(window.location.hostname + text)
      .then((r) => null);
    SnackbarEmitter(
      SNACKBAR_VARIANT.SUCCESS,
      `${t("IDS_WP_ALREADY_COPY")} link`
    );
  };

  const _handleAddMember = () => {
    setIsOpenAddModal(true);
  };

  const MenuProject = () => {
    return (
      <Menu
        id="simple-menu"
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={(evt) => setMenuAnchor(null)}
        transformOrigin={{
          vertical: -30,
          horizontal: "right",
        }}
      >
        {get(curProject, "can_update", false) && (
          <>
            {!isShared && (
              <MenuItem
                onClick={(evt) => {
                  setMenuAnchor(null);
                  handleOpenModal("SETTING", {
                    curProject,
                    canChange: {
                      date: true,
                      copy: true,
                      view: true,
                    },
                  });
                }}
              >
                <span>
                  <Icon path={mdiSettings} size={1} color={"#a4a4a4"} />
                  {t("DMH.VIEW.PGP.RIGHT.ALL.SETTING")}
                </span>
              </MenuItem>
            )}
            <MenuItem
              onClick={(evt) => {
                setMenuAnchor(null);
                handleCopyText(curProject.url_redirect);
              }}
            >
              <span>
                <Icon path={mdiLink} size={1} color={"#a4a4a4"} />
                {t("DMH.VIEW.PGP.RIGHT.ALL.COPY_LINK")}
              </span>
            </MenuItem>
            <MenuItem
              onClick={(evt) => {
                setMenuAnchor(null);
                handleOpenModal("EDIT_PROJECT", {
                  curProject,
                });
              }}
            >
              <span>
                <EditIcon />
                {t("DMH.VIEW.PGP.RIGHT.ALL.EDIT")}
              </span>
            </MenuItem>
            <MenuItem
              onClick={(evt) => {
                setMenuAnchor(null);
                _handleAddMember();
              }}
            >
              {/* xx */}
              <span>
                <Icon path={mdiAccountSupervisor} size={1} color={"#a4a4a4"} />
                {t("DMH.VIEW.PGP.RIGHT.ALL.MEMBER")}
              </span>
            </MenuItem>
            {!isShared && (
              <MenuItem
                onClick={(evt) => {
                  setMenuAnchor(null);
                  handleShowOrHideProject(curProject);
                }}
                disabled={showHideDisabled}
              >
                {showHideDisabled && (
                  <CircularProgress
                    size={16}
                    className="margin-circular"
                    color="white"
                  />
                )}
                {get(curProject, "visibility", false) ? (
                  <span>
                    <Icon path={mdiEyeOff} size={1} color={"#a4a4a4"} />
                    {t("DMH.VIEW.PGP.RIGHT.ALL.HIDE")}
                  </span>
                ) : (
                  <span>
                    <Icon path={mdiEye} size={1} color={"#a4a4a4"} />
                    {t("DMH.VIEW.PGP.RIGHT.ALL.SHOW")}
                  </span>
                )}
              </MenuItem>
            )}
            <MenuItem
              onClick={(evt) => {
                setMenuAnchor(null);
                !get(curProject, "is_shared", false)
                  ? setOpenShare(true)
                  : onUnShareProject();
              }}
            >
              {!get(curProject, "is_shared", false) ? (
                <span>
                  <Icon path={mdiShare} size={1} color={"#a4a4a4"} />
                  {t("DMH.VIEW.PGP.RIGHT.ALL.SHARE_LIB")}
                </span>
              ) : (
                <span>
                  <Icon path={mdiDoNotDisturb} size={1} color={"#a4a4a4"} />
                  {t("DMH.VIEW.PGP.RIGHT.ALL.UN_SHARE_LIB")}
                </span>
              )}
            </MenuItem>
            <MenuItem
              onClick={(evt) => {
                setMenuAnchor(null);
                setVisible("move");
                setItemToMove(curProject);
              }}
            >
              <span>
                <DriveFileMoveOutlinedIcon />
                {t("DMH.VIEW.PGP.RIGHT.ALL.MOVE")}
              </span>
            </MenuItem>
          </>
        )}
        {get(curProject, "can_delete", false) && !isShared && (
          <MenuItem
            onClick={(evt) => {
              setMenuAnchor(null);
              handleOpenModal("ALERT", {
                selectedProject: curProject,
              });
            }}
          >
            <span className="task-group__menu-item--delete">
              <DeleteOutlineOutlinedIcon />
              {t("DMH.VIEW.PGP.RIGHT.ALL.DEL_BOARD")}
            </span>
          </MenuItem>
        )}
      </Menu>
    );
  };

  const MenuProjectGroup = () => {
    return (
      <Menu
        id="simple-menu"
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={(evt) => setMenuAnchor(null)}
        transformOrigin={{
          vertical: -30,
          horizontal: "right",
        }}
      >
        {canModifyProjectGroup && (
          <MenuItem
            onClick={(evt) => {
              setMenuAnchor(null);
              handleOpenModal("UPDATE", {
                updatedProjectGroup: currentGroupAction,
              });
            }}
          >
            <span>
              <ModeEditOutlineOutlinedIcon />
              {t("DMH.VIEW.PGP.RIGHT.ALL.EDIT")}
            </span>
          </MenuItem>
        )}

        {canModifyProjectGroup && (
          <MenuItem
            onClick={(evt) => {
              setMenuAnchor(null);
              // history.push(`/projects?groupID=${currentGroup.id}&createTask`);
              history.push({
                pathname: "/projects/add-new",
                state: {
                  groupID: currentGroupAction.id,
                  groupName: currentGroupAction.name,
                },
              });
            }}
          >
            <span>
              <AddCircleOutlineOutlinedIcon />
              {t("DMH.VIEW.PGP.RIGHT.ALL.ADD_TABLE_TASKS")}
            </span>
          </MenuItem>
        )}
        {canModifyProjectGroup && (
          <ColorGroupPickerPopover
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            handleSelectColor={(props) => {
              setMenuAnchor(null);
              handleSelectColor(props);
            }}
            projectGroup_id={currentGroupAction?.id}
            projectGroupColor={currentGroupAction?.color}
          >
            <MenuItem
            // onClick={(evt) => {
            //   handleOpenModal("COLOR_PICKER", {
            //     projectGroup_id: currentGroup.id,
            //     projectGroupColor: currentGroup.color,
            //     handleUpdateProjectGroup: handleUpdateProjectGroup,
            //     setActiveLoading: setActiveLoading,
            //   });
            // }}
            >
              <span
              // onClick={(evt) => {
              //   handleOpenModal("COLOR_PICKER", {
              // projectGroup_id: currentGroup.id,
              // projectGroupColor: currentGroup.color,
              // handleUpdateProjectGroup: handleUpdateProjectGroup,
              // setActiveLoading: setActiveLoading,
              //   });
              // }}
              >
                <PaletteOutlinedIcon />
                {t("DMH.VIEW.PGP.RIGHT.ALL.CHANGE_COLOR")}
              </span>
            </MenuItem>
          </ColorGroupPickerPopover>
        )}
        {/* {canModifyProjectGroup && (
          <MenuItem
            onClick={(evt) => {
              setMenuAnchor(null);
              handleOpenModal("LOGO", {
                doSelectIcon: (icon) =>
                  handleUpdateProjectGroup({
                    projectGroupId: currentGroup.id,
                    icon: icon.url_sort,
                  }),
                currentGroup: currentGroup,
              });
            }}
          >
            <span>
              <InsertEmoticonOutlinedIcon />
              {t("DMH.VIEW.PGP.RIGHT.ALL.CHANGE_ICON")}
            </span>
          </MenuItem>
        )} */}
        {canModifyProjectGroup && (
          <MenuItem
            onClick={(evt) => {
              evt.stopPropagation();
              _handleSetDefault(`?groupID=${currentGroupAction.id}`);
              setMenuAnchor(null);
            }}
          >
            <span>
              <FlagOutlinedIcon />
              {t("DMH.VIEW.PGP.RIGHT.ALL.SET_DEFAULT")}
            </span>
          </MenuItem>
        )}
        {get(currentGroupAction, "can_modify", false) && (
          <MenuItem
            onClick={(evt) => {
              setMenuAnchor(null);
              setVisible("move");
              setItemToMove(currentGroupAction);
            }}
          >
            <span>
              <DriveFileMoveOutlinedIcon />
              {t("DMH.VIEW.PGP.RIGHT.ALL.MOVE")}
            </span>
          </MenuItem>
        )}
        {get(currentGroupAction, "can_modify") && (
          <MenuItem
            onClick={(evt) => {
              setMenuAnchor(null);
              handleOpenModal("DELETE_GROUP", {
                selectedProjectGroup: currentGroupAction,
              });
            }}
          >
            <span className="task-group__menu-item--delete">
              <DeleteOutlineOutlinedIcon />
              {t("DMH.VIEW.PGP.RIGHT.ALL.DEL")}
            </span>
          </MenuItem>
        )}
      </Menu>
    );
  };
  console.log(projects, "projects xxx");
  const checkShowEmptyView = () => {
    if (!projects.loading && !isFiltering) {
      if (type_data == 2 && size(projects.projects) === 0) {
        return true;
      } else if (type_data != 2) {
        if (!isNil(groupID)) {
          if (size(projects.projects) === 0) {
            return true;
          }
        } else {
          if (size(projectGroup) === 0) {
            return true;
          }
        }
      }
    }
    return false;
  };

  if (loadingCheckDeny) return <LoadingBox />;

  if (!loadingCheckDeny && isDeny) {
    return (
      <Container>
        <ProjectTableDeny
          sxWrapper={{
            height: "100vh",
          }}
        />
      </Container>
    );
  }

  return (
    <div>
      <Container>
        {/* {checkShowEmptyView() && renderEmptyView()} */}
        <HeaderTableAllGroup
          refFilterCustom={refFilterCustom}
          currentGroup={currentGroup}
          setCurrentGroup={setCurrentGroup}
          expand={expand}
          onExpand={handleExpand}
          typeData={type_data}
          filterType={filterType}
          labelType={labelType}
          timeType={timeType}
          onSearch={handleSearch}
          onFilterType={_filterType}
          onFilterLabel={_filterLabel}
          onExportData={_exportData}
          onSetTimeRangeAnchor={_setTimeRangeAnchor}
          onOpenCreateModal={(evt) =>
            isDisplayGroupGrid
              ? handleOpenModal("UPDATE")
              : handleOpenModal("CREATE")
          }
          onOpenCreateGroupModal={() => {
            handleOpenModal("UPDATE");
          }}
          isDisplayGroupGrid={isDisplayGroupGrid}
          doEditProjectGroup={doEditProjectGroup}
          handleSelectColor={handleSelectColor}
          getCurrentGroup={getCurrentGroup}
        />
        {projects.loading && <LoadingBox />}
        {!projects.loading && (
          <div>
            {isDisplayGroupGrid ? (
              <div className="cus_container_projects_groupID">
                <ProjectGroupGrid
                  expand={expand}
                  projectGroups={projectGroup}
                  onEdit={onEdit}
                  handleDragEnd={_handleDragEnd}
                  handleSortProjectGroup={handleSortProjectGroup}
                  setCurrentGroup={setCurrentGroupAction}
                  doReloadList={doReloadList}
                  setActiveLoading={setActiveLoading}
                  activeLoading={activeLoading}
                  onOpenCreateModal={(evt) => handleOpenModal("UPDATE")}
                />
              </div>
            ) : (
              <WPReactTable
                expand={expand}
                localOption={localOption}
                searchValue={searchValue}
                data={projects?.projects}
                onDragEnd={_handleDragEnd}
                refFilterCustom={refFilterCustom}
                onEdit={(evt, project, isProjectGroupParam) => {
                  // evt.stopPropagation();
                  doOpenMenu(evt, project, isProjectGroupParam);
                }}
                onOpenEditModal={(curProject) => {
                  handleOpenModal("UPDATE", {
                    curProject,
                  });
                }}
                openEditLabel={(currentProject) => {
                  setCurProject(currentProject);
                  setOpenManagerLabelModal(true);
                }}
                handleSortProjectGroup={handleSortProjectGroupAndUpdateReducer}
                setCurrentGroup={setCurrentGroup}
                setCurrentGroupAction={setCurrentGroupAction}
                doReloadList={doReloadList}
                setActiveLoading={setActiveLoading}
                activeLoading={activeLoading}
                handleOpenModal={handleOpenModal}
                groupID={groupID}
                currentGroup={currentGroup}
                getCurrentGroup={getCurrentGroup}
              />
            )}

            {(isDisplayGroupGrid || isProjectGroup) && <MenuProjectGroup />}
            {!isDisplayGroupGrid && !isProjectGroup && <MenuProject />}
          </div>
        )}
      </Container>

      <TimeRangePopover
        className="time-range-popover"
        bgColor={bgColor}
        anchorEl={timeAnchor}
        setAnchorEl={setTimeAnchor}
        timeOptionDefault={timeType}
        handleTimeRange={(timeType, startDate, endDate) => {
          handleTimeType(timeType);
          // handleTimeRange(startDate, endDate);
        }}
      />

      <EditProjectModal
        open={openEditProject}
        setOpen={setOpenEditProject}
        projectGroupId={groupID}
        projectGroupName={currentGroup?.name}
        disableChooseGroup={true}
        customDoReload={(project) => {
          let listProject = projects?.projects;
          listProject = listProject.map((item) => {
            if (item.id === project.id) {
              return {
                ...item,
                ...project,
              };
            }
            return item;
          });
          console.log(openEditProject, "edit project");
          updateProjectData({ projects: listProject });
        }}
        {...editProjectProps}
      />

      {visible === "move" && (
        <MoveGroupAndTabletModal
          open={visible === "move"}
          onClose={closeModal}
          onOk={(isProjectGroup, dataMove) => {
            // doReloadList();
            setTimeout(() => {
              history.push(`/projects?groupID=${dataMove.projectGroupId}`);
            }, 200);
            // if (!isProjectGroup && dataMove.projectGroupId !== groupID) {
            //   let listProject = projects?.projects;
            //   listProject = listProject.filter(
            //     (item) => item.id !== dataMove.projectId
            //   );
            //   updateProjectData({ projects: listProject });
            // }
          }}
          itemToMove={itemToMove}
          isProjectGroup={isProjectGroup}
        />
      )}

      <CreateProjectGroup
        open={openEdit}
        setOpen={setOpenEdit}
        {...editProps}
        getCurrentGroup={getCurrentGroup}
      />

      <ShareProjectModal
        projectId={get(curProject, "id", "")}
        nameTaskProject={get(curProject, "name", "")}
        openModal={openShare}
        setopenModal={setOpenShare}
      />

      <MembersSettingModal
        open={isOpenAddModal}
        setOpen={setIsOpenAddModal}
        project_id={get(curProject, "id", "")}
        project={curProject}
      />
      <ManagerLabelModal
        open={openManagerLabelModal}
        setOpen={setOpenManagerLabelModal}
        projects={projects?.projects}
        curProject={curProject}
      />
    </div>
  );
}

export default connect(
  (state) => ({
    projectGroup: get(
      state.projectGroup.listProjectGroup.data,
      "projectGroups",
      []
    ),
  }),
  (dispatch) => {
    return {
      doEditProjectGroup: ({
        projectGroupId,
        name,
        icon,
        description,
        work_types,
        color,
      }) =>
        dispatch(
          editProjectGroup({
            projectGroupId,
            name,
            icon,
            description,
            work_types,
            color,
          })
        ),
    };
  }
)(AllProjectTable);
